import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, mapTo, merge, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkStatusService {
  private connectionStatus = new BehaviorSubject<boolean>(navigator.onLine);
  public status$ = this.connectionStatus.asObservable();

  constructor() {
    const online$ = fromEvent(window, 'online').pipe(mapTo(true));
    const offline$ = fromEvent(window, 'offline').pipe(mapTo(false));

    merge(online$, offline$)
      .pipe(startWith(navigator.onLine))
      .subscribe(status => this.connectionStatus.next(status));
  }
}
